import { call, put, select } from 'redux-saga/effects';
import { clearWaitingUsersList } from 'features/users/actions';
import { Action } from '@reduxjs/toolkit';
import { closeActionNotification } from 'features/notifications/thunks/closeActionNotification';
import { WAITING_ENTRY_NOTIFICATION_ID } from 'features/notifications/constants';
import { selectAwaitingEntryIds } from 'features/users/usersSlice';
import { UserId } from 'features/users/types';
import { sendWaitingUsersLeftSaga } from 'features/users/sagas/sendWaitingUsersLeftSaga';

export function* onBulkEntryRejectedSaga() {
  const awaitingEntryIds: UserId[] = yield select(selectAwaitingEntryIds);
  yield call(sendWaitingUsersLeftSaga, awaitingEntryIds);

  yield put(clearWaitingUsersList());

  const cleanupNotificationThunk: Action = yield call(
    closeActionNotification,
    WAITING_ENTRY_NOTIFICATION_ID
  );
  yield put(cleanupNotificationThunk);
}
